import { Link } from "react-router-dom";
import { motion } from "motion/react";
import { useDeviceCapabilities } from "@/hooks/useDeviceCapabilities";

interface Props {
  to: string;
  children: React.ReactNode;
  variant?: "primary" | "inverted";
  className?: string;
}

const GlowCta = ({ to, children, variant = "primary", className = "" }: Props) => {
  const isPrimary = variant === "primary";
  const { canHover } = useDeviceCapabilities();

  return (
    <motion.div
      className="inline-block rounded-full"
      whileHover={
        canHover
          ? {
              scale: 1.025,
              boxShadow: isPrimary
                ? "0 4px 16px hsl(25 20% 18% / 0.1), 0 12px 40px -8px hsl(32 35% 52% / 0.08), 0 24px 64px -16px hsl(25 20% 18% / 0.12)"
                : "0 4px 16px hsl(0 0% 100% / 0.1), 0 12px 40px -8px hsl(0 0% 100% / 0.06), 0 24px 64px -16px hsl(0 0% 0% / 0.1)",
            }
          : undefined
      }
      whileTap={{ scale: 0.97 }}
      transition={{
        duration: 0.5,
        ease: [0.22, 0.68, 0.35, 1],
      }}
    >
      <Link
        to={to}
        className={`btn-premium relative overflow-hidden inline-block ${
          isPrimary
            ? "bg-primary text-primary-foreground"
            : "bg-primary-foreground text-primary"
        } px-10 py-[1.15rem] sm:py-3.5 text-[15px] sm:text-[13px] min-h-[52px] sm:min-h-0 ${className}`}
      >
        <span className="absolute inset-0 -translate-x-full animate-[shimmer_4.5s_ease-in-out_infinite] bg-gradient-to-r from-transparent via-white/12 to-transparent" />
        <span className="relative">{children}</span>
      </Link>
    </motion.div>
  );
};

export default GlowCta;
